import React from "react";
import PropTypes from "prop-types";

import { UpArrowIcon, DownArrowIcon } from "@svgs";

export default function CollapseArrowIcon({
  isToggled,
  ...restProps
}) {
  return (
    <>
      {isToggled
        ? <UpArrowIcon className="UpArrowIcon" {...restProps} />
        : <DownArrowIcon className="DownArrowIcon" {...restProps} />
      }
    </>
  );
}

CollapseArrowIcon.propTypes = {
  isToggled: PropTypes.bool
};
